<template lang="pug">
	div
		#sfc-main-container
			sfc-sentry
			sfc-hello-bar-v3
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-login
			sfc-forgot-password
			sfc-header
			#sfc-main-content
				nuxt
		sfc-college-savings-questions-modal
</template>


<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#sfc-main-container
		background-color: sfc-pale-stone
		height: 100vh
</style>


<script>
import SfcHeader from '@/layouts/common/sfc-header-slim-no-ad'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'

export default {
	components: {
		SfcHeader,
		sfcCollegeSavingsQuestionsModal,
		SfcHelloBarV3,
		SfcLogin,
		SfcForgotPassword
	}
}
</script>
